import drawChart from "./drawChart";

// ! rename the function to align with the widget name
export const collectionKeySignatureChart = async () => {
    const el = document.querySelector('.curious-collection-key-signature-chart');
    if (!el) return;

    // ------------------------------------------------------------

        const endpoint = el.getAttribute('data-endpoint');
        if (!endpoint) {
            console.error('No endpoint specified for the sonata-variant-analysis-table widget');
            return;
        }
        const url = `${window.apiUri}${endpoint}`
        try {
            const response = await fetch(url)
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`)
            }
            const data = await response.json();

            let keySigs = data.sonatas.map(sonata => {
                return {
                    keySig: sonata.info.filter(i => i.label === 'Key signature')[0].value
                }
            }).reduce((acc, obj) => {
                const key = obj.keySig
                acc[key] = ((acc[key] || 0) + 1)
                return acc
            }, {})

            const keySigData = {
                "no sharps/flats": keySigs["no sharps/flats"] || 0,
                "1 ♯ sharp": keySigs["1 ♯ sharp"] || 0,
                "2 ♯ sharps": keySigs["2 ♯ sharps"] || 0,
                "3 ♯ sharps": keySigs["3 ♯ sharps"] || 0,
                "4 ♯ sharps": keySigs["4 ♯ sharps"] || 0,
                "5 ♯ sharps": keySigs["5 ♯ sharps"] || 0,
                "6 ♯ sharps": keySigs["6 ♯ sharps"] || 0,
                "1 ♭ flat": keySigs["1 ♭ flat"] || 0,
                "2 ♭ flats": keySigs["2 ♭ flats"] || 0,
                "3 ♭ flats": keySigs["3 ♭ flats"] || 0,
                "4 ♭ flats": keySigs["4 ♭ flats"] || 0,
                "5 ♭ flats": keySigs["5 ♭ flats"] || 0,
                "6 ♭ flats": keySigs["6 ♭ flats"] || 0
            }
            drawChart(keySigData)

            el.classList.remove('loading')
            
        } catch(error) {
            console.error(error)
        } 

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

